import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";

import CheckoutForm from ".";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import axios from "../../utils/axios";
import { APIRoutes } from "../../utils/constants";
import { useParams } from "react-router-dom";
import useConfig from "../../hooks/useConfig";
import { toast } from "react-toastify";
import HttpService from "../../hooks/Https-services";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is a public sample test API key.
// Don’t submit any personally identifiable information in requests made with this key.
// Sign in to see your own test API key embedded in code samples.

export default function Payment() {
  const configData = useConfig();
  const stripeKey: any = configData?.stripePublishableKey;
  const { clientSecret, plan_id, paymentId }: any = useParams();

  const stripePromise = loadStripe(stripeKey);
  const [plandetails, setPlanDetails] = useState<any>({});
  const [isSkeleton, setIsSkeleton] = useState(false);
  const [option, setOption] = useState({});
  const appearance = {
    theme: "stripe",
  };

  const GetPlanDetails = async () => {
    setIsSkeleton(true);
    try {
      if (plan_id == 0) {
        const res = await HttpService.get(
          APIRoutes.GetGiftCardDetails.replace(":id", paymentId)
        );

        setOption({
          clientSecret,
          appearance,
        });
        const plan = res?.data?.data;
        setPlanDetails({
          ...plandetails,
          price: `$${plan?.GiftAmount}`,
          name: plan?.RecipientsName,
          date: plan?.DeliveryDate,
          message: plan?.SortMessage,
          email: plan?.RecipientsEmail,
        });
        setIsSkeleton(false);
      } else if (plan_id == 4) {
        // HTPTV-636: gift-subscription checkout (one-time Invoice PaymentIntent).
        const res = await HttpService.get(
          APIRoutes.GetGiftSubscriptionDetails.replace(":id", paymentId)
        );
        setOption({ clientSecret, appearance });
        const plan = res?.data?.data;
        const gt = new URLSearchParams(window.location.search).get("gt");
        const tier = plan?.PlanTier
          ? plan.PlanTier.charAt(0).toUpperCase() + plan.PlanTier.slice(1)
          : "";
        const term = plan?.TermCount || 1;
        const unit =
          plan?.BillingModel === "annual"
            ? term > 1 ? "years" : "year"
            : term > 1 ? "months" : "month";
        setPlanDetails({
          ...plandetails,
          title: `Gift: ${tier} · ${term} ${unit}`,
          price: gt ? `$${Number(gt).toFixed(2)}` : "",
          name: plan?.RecipientName,
          date: plan?.DeliveryDate,
          message: plan?.PersonalMessage,
          email: plan?.RecipientEmail,
        });
        setIsSkeleton(false);
      } else {
        const plan: any = await HttpService.get(
          APIRoutes.GetPlansByID.replace(":id", plan_id)
        );

        let giftConvEnd: any = null;
        if (plan?.data?.data?.plan_type_id == 3) {
          setOption({
            clientSecret,
            appearance,
          });
        } else {
          if (clientSecret !== "0") {
            setOption({
              clientSecret,
              appearance,
            });
          } else {
            setOption({
              mode: "subscription",
              payment_method_types: [
                "card",
                // Cash App Pay only supports USD, so only offer it for USD plans
                // (CAD tenants like olatv / stansteadtv must not include it).
                (plan?.data?.data?.currency || "").toLowerCase() === "usd" && "cashapp",
              ].filter(Boolean),

              amount: Number(plan?.data?.data?.price_in_currency),
              currency: plan?.data?.data?.currency,
              appearance,
            });
            // HTPTV-636: a gift recipient converting is not charged today; the
            // plan starts (first charge) when their gift ends.
            try {
              const mine = await HttpService.get(APIRoutes.MyGiftEntitlement);
              if (mine?.data?.data?.hasGift) {
                giftConvEnd = mine.data.data.entitlementEnd;
              }
            } catch (e) {}
          }
        }

        setPlanDetails({
          ...plan?.data?.data,
          ...(giftConvEnd
            ? { isGiftConversion: true, giftEnd: giftConvEnd }
            : {}),
        });
        setIsSkeleton(false);
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setIsSkeleton(false);
    }
  };
  useEffect(() => {
    GetPlanDetails();
  }, []);
  return (
    <div className="App">
      {!isSkeleton && (
        <Elements options={option} stripe={stripePromise}>
          <CheckoutForm plandetails={plandetails} />
        </Elements>
      )}
    </div>
  );
}
